import React, { useState, useEffect, useRef } from "react";
import {
  View,
  TouchableOpacity,
  Text,
  Alert,
  StyleSheet,
  Modal,
  ScrollView,
  TextInput,
  ActivityIndicator,
} from "react-native";

import { useTranslation } from "react-i18next";

import { FontAwesome } from "@expo/vector-icons";

import Colors from "../../../Resources/Color";
import Fonts from "../../../Resources/Fonts";
import GlobalStyles from "../../../Resources/Styles";

import { observer, Observer } from "mobx-react";

import { Octicons } from "@expo/vector-icons";
import { Ionicons } from "@expo/vector-icons";
import { Menu, MenuItem, MenuDivider } from "react-native-material-menu";
import { useScreenDimensions, useDevice } from "../../_layout";
const ClientFeeHistory = ({ isVisible, onClose, client }) => {
  const { t } = useTranslation();

  const { screenWidth, screenHeight, ultraWideScreen, screenSize } =
    useScreenDimensions();
  const { isMobile } = useDevice();

  const FeeHistoryTableHeader = () => {
    return (
      <View
        style={{
          backgroundColor: Colors.lightGrayColor,
          height: 50,
          borderTopLeftRadius: 14,
          borderTopRightRadius: 14,
          borderWidth: 0.1,
          borderColor: Colors.borderColor,
          alignItems: "center",
        }}
      >
        <View
          style={[
            GlobalStyles.HStack,
            {
              width: "100%",
              height: "100%",
              justifyContent: "space-between",
              paddingHorizontal: 10,
            },
          ]}
        >
          <View
            style={{
              width: "12%",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text
              style={{
                textAlign: "center",
                fontSize: 14,
                fontWeight: "600",
                // color: Colors.blackColor,
                color: "rgb(108, 115, 127)",
              }}
            >
              {t("beginningOfQuotaHeader-string")}
            </Text>
          </View>

          <View
            style={{
              width: "10%",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text
              style={{
                textAlign: "center",
                fontSize: 14,
                fontWeight: "600",
                // color: Colors.blackColor,
                color: "rgb(108, 115, 127)",
              }}
            >
              {t("feeHeader-string")}
            </Text>
          </View>

          <View
            style={{
              width: "10%",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text
              style={{
                textAlign: "center",
                fontSize: 14,
                fontWeight: "600",
                // color: Colors.blackColor,
                color: "rgb(108, 115, 127)",
              }}
            >
              {t("quotaTypeHeader-string")}
            </Text>
          </View>

          <View
            style={{
              width: "12%",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text
              style={{
                textAlign: "center",
                fontSize: 14,
                fontWeight: "600",
                // color: Colors.blackColor,
                color: "rgb(108, 115, 127)",
              }}
            >
              {t("endOfQuotaHeader-string")}
            </Text>
          </View>

          <View
            style={{
              width: "25%",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text
              style={{
                textAlign: "center",
                fontSize: 14,
                fontWeight: "600",
                // color: Colors.blackColor,
                color: "rgb(108, 115, 127)",
              }}
            >
              {t("actionsHeader-string")}
            </Text>
          </View>
        </View>
      </View>
    );
  };
  const FeeRow = ({ fee, index }) => {
    const DateInput = observer(() => {
      return (
        <View
          style={{
            flexDirection: "row",
            width: "100%",
            justifyContent: "center",
          }}
        >
          <Text
            style={{
              width: "100%",
              color: "black",
              textAlign: "center",
              fontSize: 12,
              // padding: 2,
            }}
          >
            {fee.fee_start_date_day} / {fee.fee_start_date_month} /{" "}
            {fee.fee_start_date_year}
          </Text>
        </View>
      );
    });

    const FeeText = () => {
      return (
        <View
          style={{
            width: "100%",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Text
            numberOfLines={1}
            style={{
              width: "100%",
              color: "black",
              textAlign: "center",
              fontSize: 12,
              padding: 2,
            }}
          >
            {t("feeWithCurrency-string", { fee: fee.fee })}
          </Text>
        </View>
      );
    };

    const FeeType = observer(() => {
      return (
        <View style={{ width: "10%", alignItems: "center" }}>
          <Text
            style={[
              Fonts.regular12,
              {
                textAlign: "center",
                textAlignVertical: "center",
                color: Colors.blackColor,
              },
            ]}
          >
            {t(fee.fee_type)}
          </Text>
        </View>
      );
    });

    const EndDate = observer(() => {
      const feeTypeIndex =
        fee.fee_type === "Trimestral"
          ? 3
          : fee.fee_type === "Semestral"
          ? 6
          : fee.fee_type === "Anual"
          ? 12
          : 1;
      const endMonthIndex = fee.fee_start_date_month + feeTypeIndex;

      const endMonthReturn =
        endMonthIndex > 12 ? endMonthIndex - 12 : endMonthIndex;

      const endYearReturn =
        endMonthIndex > 12
          ? fee.fee_start_date_year + 1
          : fee.fee_start_date_year;
      return (
        <Text
          style={{
            width: "100%",
            color: Colors.blackColor,
            textAlign: "center",
            fontSize: 12,
            // padding: 2,
          }}
        >
          {fee.fee_start_date_day} / {endMonthReturn} / {endYearReturn}
        </Text>
      );
    });

    const Actions = () => {
      const [showingConfirmation, setShowingConfirmation] = useState(false);
      const ActionButton = observer(({ bool }) => {
        const text = bool ? "confirm-string" : "cancel-string";

        const action = () => {
          if (bool) {
            // Assuming you have a way to uniquely identify the fee to be deleted
            // For example, if you have the fee's index or a unique ID
            const feeIndex = client.feeHistory.findIndex(
              (feeToFind) => feeToFind.id === fee.id
            );

            // Delete the fee from the array if it exists
            if (feeIndex > -1) {
              const updatedFeeHistory = [...client.feeHistory]; // Create a copy of the feeHistory array
              updatedFeeHistory.splice(feeIndex, 1); // Remove the fee at the found index
              client.setProperty("feeHistory", updatedFeeHistory); // Update the client's feeHistory with the modified array
              //   client.feeHistory = updatedFeeHistory;

              // Assuming you have a method in your client class to handle data updates
              client.uploadData({ fee_history: updatedFeeHistory });
            }
          } else {
            setShowingConfirmation(false);
          }
        };

        const [isHovered, setIsHovered] = useState(false);

        return (
          <TouchableOpacity
            onPress={action}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <View
              style={{
                backgroundColor: bool
                  ? "red"
                  : isHovered
                  ? Colors.bubbleColor
                  : "transparent",
                borderRadius: 12,
                justifyContent: "center",
                borderWidth: 0.5,
                borderColor: bool ? "red" : Colors.bubbleColor,
                // height: 30,
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
                paddingHorizontal: 8,
                paddingVertical: 6,
                opacity: bool && isHovered ? 0.7 : 1,
              }}
            >
              <Text
                style={[
                  Fonts.regular14,
                  {
                    textAlignVertical: "center",
                    textAlign: "center",
                    color: bool
                      ? Colors.whiteColor
                      : isHovered
                      ? "white"
                      : Colors.bubbleColor,
                    // marginHorizontal: 10,
                  },
                ]}
              >
                {t(text)}
              </Text>
            </View>
          </TouchableOpacity>
        );
      });
      const DeleteButton = () => {
        const [isHovered, setIsHovered] = useState(false);

        return (
          <TouchableOpacity
            onPress={() => {
              if (!client.isOffline) {
                setShowingConfirmation(true);
              }
            }}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <View
              style={{
                backgroundColor: isHovered ? Colors.redColor : "transparent",
                borderRadius: 12,
                justifyContent: "center",
                borderWidth: 0.5,
                borderColor: "red",
                // height: 30,
                paddingHorizontal: 8,
                paddingVertical: 6,

                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
                paddingHorizontal: 10,
                opacity: client.isOffline ? 0.5 : 1,
              }}
            >
              <Text
                style={[
                  Fonts.regular14,
                  {
                    textAlignVertical: "center",
                    textAlign: "center",
                    color: isHovered ? "white" : Colors.redColor,
                  },
                ]}
              >
                {t("delete-string")}
              </Text>
            </View>
          </TouchableOpacity>
        );
      };
      return (
        <View
          style={{
            width: "25%",
            flexDirection: "row",
            justifyContent: "space-around",
            alignItems: "center",
          }}
        >
          {showingConfirmation ? (
            <>
              <ActionButton bool={false} />
              <ActionButton bool={true} />
            </>
          ) : (
            <DeleteButton />
          )}
        </View>
      );
    };

    return (
      <View
        style={{
          backgroundColor: "white",
          height: 50,
          borderBottomRightRadius:
            index === client.feeHistory.length - 1 ? 14 : 0,
          borderBottomLeftRadius:
            index === client.feeHistory.length - 1 ? 14 : 0,
          borderBottomWidth: 0.1,
          borderRightWidth: 0.1,
          borderLeftWidth: 0.1,
          borderColor: Colors.borderColor,
          alignItems: "center",
        }}
      >
        <View
          style={[
            GlobalStyles.HStack,
            {
              width: "100%",
              paddingHorizontal: 10,
              flex: 1,
              justifyContent: "space-between",
            },
          ]}
        >
          <View style={{ width: "12%" }}>
            <DateInput />
          </View>

          <View style={{ width: "10%" }}>
            <FeeText />
          </View>

          <FeeType />

          <View style={{ width: "12%" }}>
            <EndDate />
          </View>

          <Actions />
        </View>
      </View>
    );
  };
  const Cancel = () => {
    client.setProperty("selectedToRenew", false);
    onClose();
  };

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={isVisible}
      onRequestClose={Cancel}
    >
      <View style={GlobalStyles.centeredView}>
        <TouchableOpacity
          onPress={Cancel}
          style={GlobalStyles.touchableBackground}
        >
          <View />
        </TouchableOpacity>
        <View
          style={[
            styles.modalView,
            {
              position: "absolute",
              maxWidth: screenSize != "large" ? "90%" : 800,
              maxHeight: "90%",
              alignItems: "center",
              padding: 24,
              justifyContent: "space-around",
            },
          ]}
          onStartShouldSetResponder={() => false}
        >
          <Text style={[Fonts.bold16, { alignSelf: "flex-start" }]}>
            {t("quotaHistoryOfClient-string", { name: client.nameForCoach })}
          </Text>
          <ScrollView
            horizontal={true}
            style={{
              width: "100%",
              height: "100%",
              // flexDirection: "row",
            }}
            contentContainerStyle={{ flex: 1 }}
            showsHorizontalScrollIndicator={false}
          >
            <View
              style={{
                minWidth: 665,
              }}
            >
              <View style={{ marginTop: 16 }}>
                <FeeHistoryTableHeader />
              </View>
              <Observer>
                {() => (
                  <ScrollView
                    style={{ flex: 1, marginBottom: 5 }}
                    contentContainerStyle={{}}
                    showsVerticalScrollIndicator={false}
                  >
                    {client.sortedFeeHistory.map((fee, index) => (
                      <FeeRow fee={fee} key={index} index={index} />
                    ))}
                  </ScrollView>
                )}
              </Observer>
            </View>
          </ScrollView>
          {/* </View> */}
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalView: {
    // width: 800,
    // maxHeight: screenHeight * 0.5,
    borderRadius: 18,
    backgroundColor: Colors.whiteColor,
  },
  title: {
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 20,
  },
  textInputStyle: {
    width: "100%",
    height: 40,
    borderColor: "gray",
    borderWidth: 1,
    marginBottom: 20,
    padding: 10,
    borderRadius: 10,
  },
  saveButtonStyle: {
    backgroundColor: "#2196F3",
    borderRadius: 20,
    padding: 10,
    elevation: 2,
    width: "100%",
    alignItems: "center",
  },
  saveButtonText: {
    color: "white",
    fontSize: 16,
  },
  textInputStyle: {
    // height: 40,
    // marginBottom: 20,
    // marginHorizontal: 10,
    flex: 1,
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 12,
    borderWidth: 0,
    fontWeight: "400",
    fontSize: 16,
    // backgroundColor: "red",
  },
  searchBar: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
    borderWidth: 0.2,
    borderColor: Colors.grayColor,
    marginBottom: 20,
    borderRadius: 10,
    height: 40,
    backgroundColor: "transparent",
  },
});

export default ClientFeeHistory;
